import { CircularProgress } from "@mui/material";
import React from "react";

const CustomBtn = ({ title, onClickHandler, widthInPx, disabled, loading }) => {
  return (
    <button className="custom-btn" style={{width: `${widthInPx}px`}} onClick={onClickHandler} disabled={disabled}>
      {loading ? <CircularProgress style={{height: "25px", width: "25px"}}/> : title}
    </button>
  );
};

export default CustomBtn;
